import React from 'react'
import styled from "@emotion/styled";
import sv from "../../styles/styles";
import moment from "moment";
import {withTranslation} from "react-i18next";
import {NavigateBefore, NavigateNext} from '@material-ui/icons';

// STYLE ##########################################################

const Container = styled('div')`
	flex: 1;
	flex-wrap: wrap;
	${sv.flexRow};
	justify-content: space-between;
`;

const DisplayElement = styled('div')`
	min-width: 50px;
	order: ${props => props.left ? '0' : (props => props.center ? '1' : '2')};
	justify-content: ${props => props.left ? 'flex-start' : (props => props.center ? 'center' : 'flex-end')};
	@media(max-width: 600px) {
        min-width: 0;
    }
`;

const Pager = styled('div')`
	cursor: pointer;
	${sv.flexRow};
`;

const PagerIcon = styled('div')`
	display: flex;
	@media(max-width: 600px) {
        svg {
            font-size: 2.25em;
        }
    }
`;

const PagerLabel = styled('div')`
	font-size: 10;
	@media(max-width: 600px) {
        display: none;
    }
`;

const DateRangeDisplay = styled('div')`
	${sv.flexRow}
	@media(max-width: 600px) {
		${sv.flexColumn}
	}
`;

const Date = styled('div')`
	padding: 2px 5px;
`;

const DateDivider = styled('div')`
	padding: 0 5px;
`;

// COMPONENT ##########################################################

const ZoomRecordingListDates = ({ data, updateRecordingList, t }) => {

	const startDate = data.from;
	const endDate = data.to;
	const dateFormat = "YYYY-MM-DD";

	const handleEarlier = () => {
		const newStart = moment(startDate, dateFormat).subtract(1, "months").format(dateFormat);
		updateList(newStart, startDate);    // new end date is the previous start date
	};

	const handleLater = () => {
		const newEnd = moment(endDate, dateFormat).add(1, "months").format(dateFormat);
		updateList(endDate, newEnd);        // new start date is the previous end date
	};

	const updateList = (newStartDate, newEndDate) => {
		const query = {
			"from": newStartDate,
			"to": newEndDate
		};
		updateRecordingList(query);
	};

	const formattedStartDate = moment(startDate, dateFormat).format('MMMM D');
	const formattedEndDate = moment(endDate, dateFormat).format('MMMM D, YYYY');

	const showLater = () => {
		const current = moment();
		const endM = moment(endDate, dateFormat);
		return endM.isBefore(current.format(dateFormat), "day");
	};

	return (
		<Container>
			{/* Date Control left */}
			<DisplayElement left>
				<Pager onClick={handleEarlier}>
					<PagerIcon><NavigateBefore/></PagerIcon>
					<PagerLabel>{t('Earlier')}</PagerLabel>
				</Pager>
			</DisplayElement>

			{/* Date Display */}
			<DisplayElement center>
				<DateRangeDisplay>
					<Date>{formattedStartDate}</Date>
					<DateDivider>-</DateDivider>
					<Date>{formattedEndDate}</Date>
				</DateRangeDisplay>
			</DisplayElement>

			{/* Date Control right */}
			<DisplayElement right>
				{ showLater() &&
				<Pager onClick={handleLater}>
					<PagerLabel>{t('Later')}</PagerLabel>
					<PagerIcon><NavigateNext/></PagerIcon>
				</Pager>
				}
			</DisplayElement>
		</Container>
	)
};

const connectedZoomRecordingListDates = withTranslation()(ZoomRecordingListDates);
export { connectedZoomRecordingListDates as ZoomRecordingListDates };